<template>
  <div class="search">
    <div class="classForClickOutside" @click="setIsSearchDropDownVisible(false)"></div>

    <button class="search-revoke" v-show="isSearchComplete" @click="cancelSearch">
      <span class="fal fa-undo search-revoke__icon"></span>
      검색 취소
    </button>

    <div class="search-bar" @keyup.down="hoverDown" @keyup.up="hoverUp">
      <label for="search-bar-input-approval" class="blind">검색창</label>
      <input
        id="search-bar-input-approval"
        type="text"
        autocomplete="off"
        maxlength="30"
        placeholder="문서 검색"
        v-on:input="typing"
        @focus="setIsSearchDropDownVisible(true)"
        v-model="searchString"
        v-on:keyup.enter="enterSearch"
      />

      <button class="search-button" type="button" @click="search('all')" aria-label="검색">
        <i class="fal fa-search" aria-hidden="true"></i>
        <span class="blind">검색</span>
      </button>
    </div>

    <div class="search-dropdown" v-show="isSearchDropDownVisible" @mouseleave="setActiveIndex(-1)">
      <ul class="search-dropdown__menu">
        <li
          v-show="searchString"
          v-for="(searchBoxInfo, index) in searchBoxInfoList"
          :key="index"
          :class="activeIndex === index ? 'active' : null"
          @mouseover="setActiveIndex(index)"
        >
          <a class="search-dropdown__menu--row" @click="searchBoxInfo.clickFunc"
            >{{ searchBoxInfo.searchName }}: <span class="bold">{{ searchString }}</span></a
          >
        </li>

        <li v-show="searchString" class="divider" />
        <li
          v-show="searchString"
          :class="activeIndex === searchBoxInfoList.length ? 'active' : null"
          @mouseover="setActiveIndex(searchBoxInfoList.length)"
        >
          <a class="search-dropdown__menu--row contents-search" @click="contentSearch">
            <i class="fal fa-search" aria-hidden="true" style="color: #909090"></i>
            '{{ searchString }}'로 본문 검색</a
          >
        </li>

        <li @mouseover="setActiveIndex(-1)">
          <a class="search-dropdown__menu--row point-color" @click="openDetailSearch">상세 검색</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BoardSearchBox',
  data() {
    return {
      searchString: '',
      isSearchComplete: false,
      activeIndex: -1,
      searchBoxInfoList: [
        {
          searchName: '전체',
          clickFunc: () => this.search('all'),
        },
        {
          searchName: '제목',
          clickFunc: () => this.search('title'),
        },
        {
          searchName: '기안자',
          clickFunc: () => this.search('register'),
        },
        {
          searchName: '기안 부서',
          clickFunc: () => this.search('node_name'),
        },
        {
          searchName: '문서 번호',
          clickFunc: () => this.search('document_code'),
        },
        {
          searchName: '문서 종류',
          clickFunc: () => this.search('form'),
        },
      ],
    };
  },
  props: {
    isSearchDropDownVisible: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    let self = this;
    window.hideCancelSearch = function() {
      self.hideCancelSearch();
    };
  },
  methods: {
    hoverUp() {
      if (this.activeIndex <= 0) {
        return false;
      }
      this.activeIndex--;
    },
    hoverDown() {
      if (this.activeIndex >= this.searchBoxInfoList.length - 1) {
        return false;
      }
      this.activeIndex++;
    },
    setActiveIndex(index) {
      this.activeIndex = index;
    },
    typing(event) {
      if (event.target.value.length <= 0) {
        return false;
      }
      this.searchString = event.target.value;
      if (!this.isSearchDropDownVisible) {
        this.$emit('set-is-search-drop-down-visible', true);
      }
    },
    setIsSearchDropDownVisible(isVisible) {
      this.$emit('set-is-search-drop-down-visible', isVisible);
    },
    enterSearch() {
      if (this.activeIndex <= -1) {
        this.searchBoxInfoList[0].clickFunc();
      } else {
        this.searchBoxInfoList[this.activeIndex].clickFunc();
      }
    },
    search(type) {
      if (this.searchString.length < 2) {
        window.showNoticeToast('2글자 이상 입력하세요.');
        return false;
      }
      this.isSearchComplete = true;
      this.setIsSearchDropDownVisible(false);
      window.Approval.searchBar(type, this.searchString);
    },
    openDetailSearch() {
      this.setIsSearchDropDownVisible(false);
      window.Approval.getSearchLayer();
    },
    cancelSearch() {
      window.Approval.resetDocumentBoxList('ALL');
      this.hideCancelSearch();
    },
    contentSearch() {
      this.search('content');
    },
    hideCancelSearch() {
      this.isSearchComplete = false;
      this.setIsSearchDropDownVisible(false);
    },
  },
};
</script>
